<!-- 				-->
<!-- Confirm Dialog -->
<!-- 				-->
<p-confirmDialog [style]="{ width: '400px' }" [baseZIndex]="10000"></p-confirmDialog>

<div class="main-top-group">
	<!--  	   	 	 -->
	<!-- TOP SECTION -->
	<!-- 			 -->
	<div class="column-group">
		<div class="column1">
			<!-- 	     -->
			<!-- Message -->
			<!-- 	     -->
			<div class="column-item">
				<div>
					<label class="column-item-label">Message</label>
				</div>

				<div style="margin-left: 10px">
					<p-colorPicker [(ngModel)]="rMessagecolor"></p-colorPicker>
				</div>

				<div style="margin-left: 2px">
					<input type="text" pInputText [(ngModel)]="rMessage" [style.color]="rMessagecolor" maxlength="100" style="width: 640px" />
				</div>

				<div>
					<label class="column-item-label">Max 100 characters</label>
				</div>
			</div>

			<!--  	   	            -->
			<!-- Homeroom Selector  -->
			<!-- 		            -->
			<div class="column-item" [style.display]="AlertCD == 'HORO' ? 'flex' : 'none'">
				<div>
					<label class="column-item-label">Homeroom</label>
				</div>

				<div style="margin-left: 10px; width: 153px">
					<!-- Note: (ngModelChange) must go after [(ngModel)] or you get prev selected item!  -->
					<select
						class="form-control"
						name="SelectedHomeroomSelector"
						style="font-size: smaller"
						[(ngModel)]="SelectedHomeroom"
						(ngModelChange)="onHomeroomChange($event)"
					>
						<option *ngFor="let r of lstHomeroomItems" [ngValue]="r">
							{{ r.Homeroom }}
						</option>
					</select>
				</div>
			</div>

			<!--  	   	         -->
			<!-- Sound Selector  -->
			<!-- 		         -->
			<div class="column-item">
				<div>
					<label class="column-item-label">Sound</label>
				</div>

				<div style="margin-left: 10px; width: 153px">
					<!-- Note: (ngModelChange) must go after [(ngModel)] or you get prev selected item!  -->
					<select
						class="form-control"
						name="SelectedSoundSelector"
						style="font-size: smaller"
						[(ngModel)]="SelectedSound"
						(ngModelChange)="onSoundChange($event)"
					>
						<option *ngFor="let r of lstSoundItems" [ngValue]="r">
							{{ r.SoundFile }}
						</option>
					</select>
				</div>

				<div style="margin-left: 5px">
					<button class="btn btn-primary btn-sm" style="margin-left: 5px" (click)="onPlay()" [disabled]="isBusy == true">Play</button>
					<button class="btn btn-primary btn-sm" style="margin-left: 5px" (click)="onStop()" [disabled]="isBusy == true">Stop</button>
				</div>

				<!-- 				   -->
				<!-- Display When Busy -->
				<!-- 				   -->
				<div style="margin-left: 15px; width: 20px" [style.display]="isBusy == true ? 'block' : 'none'">
					<img class="busy-img" src="assets/images/loading.gif" />
				</div>
			</div>
		</div>
	</div>
</div>

<div class="main-stationmode-group">
	<div>
		<!-- 					  -->
		<!-- Display UnAssigned   -->
		<!-- 					  -->
		<div class="table-main-body">
			<!-- Note: resizableColumns breaks the multiline ability -->
			<p-table
				#dtAssigned
				[value]="lstStationModeItems"
				[paginator]="true"
				[(rows)]="pagerows"
				[(first)]="pagefirst"
				[showCurrentPageReport]="true"
				[resizableColumns]="false"
				sortMode="multiple"
				styleClass="p-datatable-striped"
				selectionMode="multiple"
				(onSort)="onHandleSort($event)"
				currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries"
				[rowsPerPageOptions]="[5, 10]"
			>
				<ng-template pTemplate="header">
					<!-- 			  -->
					<!-- Sort Section -->
					<!-- 			  -->
					<tr>
						<th class="fixwidth-04">
							<p-checkbox [(ngModel)]="isSelectAll" [binary]="true" (onChange)="onSelectAll($event)"></p-checkbox>
						</th>
						<th pSortableColumn="StationModeDesc">Station Modes<p-sortIcon field="StationModeDesc"></p-sortIcon></th>
					</tr>
				</ng-template>

				<ng-template pTemplate="body" let-rStationModeItem>
					<tr>
						<td class="fixwidth-04">
							<div>
								<p-checkbox [(ngModel)]="rStationModeItem.Active" [binary]="true"></p-checkbox>
							</div>
						</td>

						<td>
							<div>
								{{ rStationModeItem.StationModeDesc }}
							</div>
						</td>
					</tr>
				</ng-template>
			</p-table>
		</div>

		<!-- 						       	  -->
		<!-- Display When No UnAssigned Modes -->
		<!-- 						       	  -->
		<div style="padding: 20px" [style.display]="lstStationModeItems.length < 1 && isBusy == false ? 'block' : 'none'">
			<label>No Station Modes To Select...</label>
		</div>
	</div>
</div>

<!--				-->
<!-- Error Message  -->
<!--				-->
<div class="main-error-group" [style.display]="ErrorMessage.length == 0 ? 'none' : 'block'">
	<div class="error-div">
		<label class="error-message">{{ ErrorMessage }}</label>
	</div>
</div>

<!-- 		 -->
<!-- Buttons -->
<!-- 		 -->
<div style="margin-top: 20px">
	<button class="btn btn-primary" style="margin-left: 0px" (click)="onUpdate()" [disabled]="isBusy == true">Update</button>
	<button class="btn btn-primary" style="margin-left: 5px" (click)="onClose()">Cancel</button>
</div>
